import RegistrationFlow from '@/components/MasterclassDescriptionPage/PaymentFlow';
import useScreenWidth from '@/hooks/useScreenWidth';
import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { MASTERCLASS_REGISTRATION_AND_CLASS_STATUS } from '@/utils/common/masterclassDescription';
import { Tooltip, Typography } from '@pwskills/rachnaui';
import { ArrowBack } from '@pwskills/rachnaui/Icons';
import { useRouter } from 'next/router';
import HeroSectionBg from '../../../assets/icons/hero-section-bg.svg';

interface HeroSectionDashProps {
  registrationStatus: any;
  isMasterclassBought: boolean;
  isFixed: boolean;
  priceDetails: any;
  setIsMasterclassBought: (value: boolean) => void;
}

const HeroSectionDash = ({
  registrationStatus,
  isMasterclassBought,
  isFixed,
  priceDetails,
  setIsMasterclassBought,
}: HeroSectionDashProps) => {
  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );
  const router = useRouter();
  const width = useScreenWidth();
  const { pricing, batchName } = masterclassDetails;
  const isClassEnded = () => {
    return registrationStatus === MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.CLASS_ENDED;
  };
  const getDiscountedPrice = (priceData: any) => {
    let discountedPrice = priceData?.IN;
    if (
      typeof priceData?.IN === 'number' &&
      typeof priceData?.discount === 'number' &&
      priceData.discount > 0
    ) {
      const discountRupees = (priceData.IN * priceData.discount) / 100;
      discountedPrice = priceData.IN - discountRupees;
    }

    return discountedPrice;
  };
  return (
    <div className="w-full h-auto z-30 relative">
      <img
        src={HeroSectionBg}
        alt="hero-section-bg"
        className="object-cover medium:h-[356px] h-full w-full absolute"
      />
      <div className="medium:h-[356px] h-full relative py-5">
        <div className="w-full h-auto py-12 large:!py-4 px-4 large:!px-8  relative">
          <button
            className="flex items-center gap-1"
            onClick={() => {
              router.push('/dashboard/overview');
            }}
            type="button"
          >
            <ArrowBack className="text-gray-650 w-4 h-4" />
            <Typography component="body-small" variant="medium" className="text-gray-650">
              Back to overview
            </Typography>
          </button>
          <div className="flex w-full  medium:flex-row large:flex-row small:flex-col-reverse flex-col-reverse gap-6 mt-4 justify-between">
            {/* Left Side: Masterclass Content */}
            <div className="w-full medium:!w-1/2  flex flex-col justify-between text-left small:text-center">
              <p className="text-[20px] text-gray-850 font-bold">{batchName || ''}</p>
              <div className="flex flex-col small:justify-center justify-start gap-1">
                <p className="text-[20px] text-gray-850 font-semibold">
                  {`₹ ${
                    pricing?.IN === 0
                      ? 'Free'
                      : (getDiscountedPrice(pricing) as {
                          IN: number;
                          US: number;
                          discount: number;
                          ctaOnCard?: string;
                          pricingOnCardHero?: string;
                          isFree: boolean;
                          emiText?: string;
                        })
                  }`}
                </p>
                {!isClassEnded() && (
                  <Tooltip
                    text={registrationStatus}
                    className={`${
                      registrationStatus !== MASTERCLASS_REGISTRATION_AND_CLASS_STATUS.OPEN &&
                      !isMasterclassBought
                        ? ''
                        : 'hidden'
                    }`}
                  >
                    <RegistrationFlow
                      masterclassId={masterclassDetails?.masterclassId as string}
                      masterclassSlug={masterclassDetails?.slug as string}
                      masterclassName={masterclassDetails?.slug as string}
                      isUserRegistered={isMasterclassBought}
                      isFixed={isFixed}
                      registrationStatus={registrationStatus}
                      pricing={priceDetails}
                      setUserRegistered={setIsMasterclassBought}
                      isDashBoard={!(width && width < 640)}
                    />
                  </Tooltip>
                )}
              </div>
            </div>

            {/* Right Side: Image */}
            <div className="w-full medium:!w-[30%] flex justify-end">
              <img
                className="w-full rounded-lg"
                src={masterclassDetails?.heroSectionMeta?.bgImage}
                alt="web-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSectionDash;
